var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContactFormCheck"},[_c('div',{staticClass:"wrap"},[_c('p',{staticClass:"title"},[_vm._v("メール送信完了")]),_vm._m(0),_c('div',{staticClass:"button_cover"},[_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("トップページへ戻る")])])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" メールの送信が完了いたしました。 "),_c('br'),_vm._v("担当者からのご連絡をお待ちください。 ")])
}]

export { render, staticRenderFns }